(function () {
  'use strict';

  // ── State ────────────────────────────────────────────────────────
  const state = {
    step: 1,
    productKeys: [],
    coloursByProduct: {},
    methodKey: null,
    threadColours: '',
    positions: [],
    cut: 'mens',
    qtyByProductColour: {},
    logoFile: null,
    cloudinaryUrl: null,
    logoUploading: false,
    submitted: false,
    contact: {
      firstName: '', lastName: '', email: '', phone: '',
      street: '', city: '', state: '', postcode: '', country: '',
      businessName: '', abn: '', notes: '', referral: ''
    }
  };

  let pricing = null;

  const ALLOWED_EXTS = ['.ai', '.eps', '.svg', '.pdf', '.png', '.jpg', '.jpeg'];
  const MAX_FILE_MB  = 10;

  const CLOUDINARY_CLOUD  = 'dznux2lls';
  const CLOUDINARY_PRESET = 'CountryWorkShirts-CustomOrder';
  const MIN_ORDER = 12;

  // ── Pricing data (inline to avoid CDN caching issues) ────────────
  function fetchPricing() {
    return Promise.resolve({
      "products": {
        "half-button": {
          "name": "Long Sleeve - Half Button", "subtitle": "", "basePrice": 40,
          "availableColours": ["black","burgundy","ghost-gum-grey","gum-leaf-green","hibiscus-pink","khaki","navy","royal","sky-blue"],
          "availableCuts": ["mens","womens"],
          "availablePositions": ["left-chest","right-chest","back"]
        },
        "full-button": {
          "name": "Long Sleeve - Full Button", "subtitle": "", "basePrice": 40,
          "availableColours": ["fb-black","fb-burgundy","fb-ghost-gum-grey","fb-gum-leaf-green","fb-navy","fb-royal"],
          "availableCuts": ["mens","womens"],
          "availablePositions": ["left-chest","right-chest","pocket","back"]
        },
        "short-sleeve": {
          "name": "Short Sleeve - Half Button", "subtitle": "", "basePrice": 40,
          "availableColours": ["black","ss-burgundy","ghost-gum-grey","ss-gum-leaf-green","ss-khaki","ss-navy","ss-royal"],
          "availableCuts": ["mens","womens"],
          "availablePositions": ["left-chest","right-chest","back"]
        },
        "hi-vis": {
          "name": "Hi-Vis with Reflective Tape - AS/NZS Compliant", "subtitle": "", "basePrice": 40,
          "availableColours": ["yellow-navy","orange-navy"],
          "availableCuts": ["mens","womens"],
          "availablePositions": ["left-chest","right-chest","back"]
        },
        "rodeo": {
          "name": "Sleeveless - Half Button", "subtitle": "", "basePrice": 40,
          "availableColours": ["black","sl-burgundy","ghost-gum-grey","sl-gum-leaf-green","sl-khaki","sl-navy","sl-royal"],
          "availableCuts": ["mens"],
          "availablePositions": ["left-chest","right-chest","back"]
        },
        "kids-half-button": {
          "name": "Kids Long Sleeve - Half Button", "subtitle": "", "basePrice": 40,
          "availableColours": ["gum-leaf-green","royal","hibiscus-pink"],
          "availableCuts": ["kids"],
          "availablePositions": ["left-chest","right-chest","back"]
        }
      },
      "colours": {
        "black":             { "name": "Black",          "hex": "#1C1C1C" },
        "burgundy":          { "name": "Burgundy",       "hex": "#9A1F3D" },
        "ghost-gum-grey":    { "name": "Ghost Gum Grey", "hex": "#D9D8D2" },
        "gum-leaf-green":    { "name": "Gum Leaf Green", "hex": "#6E8F6E" },
        "hibiscus-pink":     { "name": "Hibiscus Pink",  "hex": "#E96A7A" },
        "khaki":             { "name": "Khaki",          "hex": "#B89C7B" },
        "navy":              { "name": "Navy",           "hex": "#143260" },
        "royal":             { "name": "Royal",          "hex": "#0E5FCA" },
        "sky-blue":          { "name": "Sky Blue",       "hex": "#87CEEB" },
        "fb-black":          { "name": "Black",          "hex": "#212121" },
        "fb-burgundy":       { "name": "Burgundy",       "hex": "#8A1E33" },
        "fb-ghost-gum-grey": { "name": "Ghost Gum Grey", "hex": "#E1E6E9" },
        "fb-gum-leaf-green": { "name": "Gum Leaf Green", "hex": "#90B291" },
        "fb-navy":           { "name": "Navy",           "hex": "#14427E" },
        "fb-royal":          { "name": "Royal",          "hex": "#0F66DA" },
        "polo-burgundy":      { "name": "Burgundy",       "hex": "#6B232D" },
        "polo-navy":          { "name": "Navy",           "hex": "#142555" },
        "sl-burgundy":        { "name": "Burgundy",       "hex": "#8F1B35" },
        "sl-gum-leaf-green":  { "name": "Gum Leaf Green", "hex": "#6A8B66" },
        "sl-khaki":           { "name": "Khaki",          "hex": "#B39876" },
        "sl-navy":            { "name": "Navy",           "hex": "#1C3B69" },
        "sl-royal":           { "name": "Royal",          "hex": "#0D5AB7" },
        "ss-burgundy":       { "name": "Burgundy",       "hex": "#6E132A" },
        "ss-gum-leaf-green": { "name": "Gum Leaf Green", "hex": "#6A8E69" },
        "ss-khaki":          { "name": "Khaki",          "hex": "#A98E6B" },
        "ss-navy":           { "name": "Navy",           "hex": "#16325C" },
        "ss-royal":          { "name": "Royal",          "hex": "#0849A0" },
        "hi-vis-yellow":     { "name": "Hi-vis yellow",  "hex": "#e8e017" },
        "hi-vis-orange":     { "name": "Hi-vis orange",  "hex": "#ff6a13" },
        "yellow-navy":       { "name": "Yellow / navy",  "hex": "#e8e017", "accent": "#1c2a4e" },
        "orange-navy":       { "name": "Orange / navy",  "hex": "#ff6a13", "accent": "#1c2a4e" }
      },
      "decorationMethods": {
        "embroidery":    { "name": "Embroidery",    "feePerPosition": 5.00, "needsThreadColour": true,  "blurb": "Stitched. Most durable. Best for logos with bold shapes." },
        "heat-transfer": { "name": "Heat transfer", "feePerPosition": 5.00, "needsThreadColour": false, "blurb": "Sharp full-colour finish. Good for detailed artwork." }
      },
      "positions": {
        "left-chest":  { "name": "Right Chest - When Facing", "subtitle": "Most popular" },
        "right-chest": { "name": "Left Chest - When Facing",  "subtitle": "Standard" },
        "pocket":      { "name": "Pocket",                    "subtitle": "If applicable" },
        "back":        { "name": "Back",                      "subtitle": "$15 +GST", "fee": 15 }
      },
      "sizes": {
        "mens":   ["S","M","L","XL","2XL","3XL","4XL","5XL"],
        "womens": ["8","10","12","14","16","18","20","22","24"],
        "kids":   ["6","8","10","12","14"]
      },
      "priceTiers": [
        { "minQty": 50, "basePrice": 30 },
        { "minQty": 25, "basePrice": 34 },
        { "minQty": 12, "basePrice": 40 }
      ],
      "shipping": { "freeOver": 150, "flatRate": 14.95 },
      "gst": 0.10
    });
  }

  // ── Step 1: product grid ─────────────────────────────────────────
  function renderProductGrid() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;
    grid.innerHTML = '';
    Object.entries(pricing.products).forEach(function ([key, product]) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'oc-tile oc-product-tile';
      btn.dataset.key = key;
      btn.setAttribute('aria-pressed', 'false');
      btn.innerHTML =
        '<span class="oc-tile-name">' + product.name + '</span>';
      btn.addEventListener('click', function () { toggleProduct(key); });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleProduct(key); }
      });
      grid.appendChild(btn);
    });
  }

  function toggleProduct(key) {
    const idx = state.productKeys.indexOf(key);
    if (idx === -1) {
      state.productKeys.push(key);
      if (!state.coloursByProduct[key]) state.coloursByProduct[key] = [];
      if (!state.qtyByProductColour[key]) state.qtyByProductColour[key] = {};
    } else {
      state.productKeys.splice(idx, 1);
      delete state.coloursByProduct[key];
      delete state.qtyByProductColour[key];
      if (state.productKeys.length) {
        state.positions = state.positions.filter(function (p) {
          return state.productKeys.every(function (pk) {
            return pricing.products[pk].availablePositions.includes(p);
          });
        });
      }
    }
    document.querySelectorAll('.oc-product-tile').forEach(function (tile) {
      const selected = state.productKeys.includes(tile.dataset.key);
      tile.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    validateStep(1);
    updateSummary();
  }

  // ── Step 2: colour swatches ──────────────────────────────────────
  function renderColourGrid() {
    const grid = document.getElementById('colour-grid');
    if (!grid || !state.productKeys.length) return;
    grid.innerHTML = '';
    state.productKeys.forEach(function (prodKey) {
      const product = pricing.products[prodKey];
      if (state.productKeys.length > 1) {
        const heading = document.createElement('p');
        heading.className = 'oc-colour-product-heading';
        heading.textContent = product.name;
        grid.appendChild(heading);
      }
      const selectedColours = state.coloursByProduct[prodKey] || [];
      product.availableColours.forEach(function (colKey) {
        const colour = pricing.colours[colKey];
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'oc-swatch';
        btn.dataset.key = colKey;
        btn.dataset.product = prodKey;
        btn.setAttribute('aria-pressed', selectedColours.includes(colKey) ? 'true' : 'false');
        let circleStyle = 'background:' + colour.hex + ';';
        if (colour.accent) {
          circleStyle = 'background:linear-gradient(135deg,' + colour.hex + ' 50%,' + colour.accent + ' 50%);';
        } else if (['#ffffff', '#c8b89a', '#D9D8D2', '#87CEEB', '#E1E6E9'].includes(colour.hex)) {
          circleStyle += 'border:1px solid #ccc;';
        }
        btn.innerHTML =
          '<span class="oc-swatch-circle" style="' + circleStyle + '"></span>' +
          '<span class="oc-swatch-name">' + colour.name + '</span>';
        btn.addEventListener('click', function () { toggleColour(prodKey, colKey); });
        btn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleColour(prodKey, colKey); }
        });
        grid.appendChild(btn);
      });
    });
  }

  function toggleColour(prodKey, colKey) {
    if (!state.coloursByProduct[prodKey]) state.coloursByProduct[prodKey] = [];
    const arr = state.coloursByProduct[prodKey];
    const idx = arr.indexOf(colKey);
    if (idx === -1) {
      arr.push(colKey);
    } else {
      arr.splice(idx, 1);
      if (state.qtyByProductColour[prodKey]) delete state.qtyByProductColour[prodKey][colKey];
    }
    document.querySelectorAll('.oc-swatch[data-product="' + prodKey + '"]').forEach(function (swatch) {
      swatch.setAttribute('aria-pressed', arr.includes(swatch.dataset.key) ? 'true' : 'false');
    });
    validateStep(2);
    updateSummary();
  }

  // ── Step 3: decoration method ────────────────────────────────────
  function setupMethodSelection() {
    document.querySelectorAll('.oc-method-row').forEach(function (row) {
      row.addEventListener('click', function () { selectMethod(row.dataset.key); });
      row.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectMethod(row.dataset.key); }
      });
    });
    const threadInput = document.getElementById('thread-colour-input');
    if (threadInput) {
      threadInput.addEventListener('input', function () {
        state.threadColours = threadInput.value.trim();
        validateStep(3);
      });
    }
  }

  function selectMethod(key) {
    state.methodKey = key;
    document.querySelectorAll('.oc-method-row').forEach(function (row) {
      row.setAttribute('aria-pressed', row.dataset.key === key ? 'true' : 'false');
    });
    const method = pricing.decorationMethods[key];
    const wrap   = document.getElementById('thread-colour-wrap');
    if (wrap) {
      wrap.hidden = !method.needsThreadColour;
      if (!method.needsThreadColour) {
        state.threadColours = '';
        const input = document.getElementById('thread-colour-input');
        if (input) input.value = '';
      }
    }
    validateStep(3);
    updateSummary();
  }

  // ── Step 4: positions ────────────────────────────────────────────
  function renderPositionGrid() {
    const grid = document.getElementById('position-grid');
    if (!grid || !state.productKeys.length) return;
    grid.innerHTML = '';
    const availablePositions = Object.keys(pricing.positions).filter(function (posKey) {
      return state.productKeys.every(function (pk) {
        return pricing.products[pk].availablePositions.includes(posKey);
      });
    });
    state.positions = state.positions.filter(function (p) {
      return availablePositions.includes(p);
    });
    availablePositions.forEach(function (posKey) {
      const position = pricing.positions[posKey];
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'oc-tile oc-position-tile';
      btn.dataset.key = posKey;
      btn.setAttribute('aria-pressed', state.positions.includes(posKey) ? 'true' : 'false');
      btn.innerHTML =
        '<span class="oc-tile-name">' + position.name + '</span>' +
        '<span class="oc-tile-sub">' + position.subtitle + '</span>';
      btn.addEventListener('click', function () { togglePosition(posKey); });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); togglePosition(posKey); }
      });
      grid.appendChild(btn);
    });
  }

  function togglePosition(key) {
    const idx = state.positions.indexOf(key);
    if (idx === -1) {
      state.positions.push(key);
    } else {
      state.positions.splice(idx, 1);
    }
    document.querySelectorAll('.oc-position-tile').forEach(function (tile) {
      tile.setAttribute('aria-pressed', state.positions.includes(tile.dataset.key) ? 'true' : 'false');
    });
    validateStep(4);
    updateSummary();
  }

  // ── Step 5: cut toggle + sizes by colour ─────────────────────────
  function setupStep5() {
    renderCutToggle();
    renderColourBlocks();
  }

  function effectiveCut(prodKey) {
    const cuts = pricing.products[prodKey].availableCuts;
    return cuts.length === 1 ? cuts[0] : state.cut;
  }

  function renderCutToggle() {
    const toggle = document.getElementById('cut-toggle');
    if (!toggle || !state.productKeys.length) return;
    const adultProducts = state.productKeys.filter(function (pk) {
      return pricing.products[pk].availableCuts.some(function (c) { return c !== 'kids'; });
    });
    if (!adultProducts.length) {
      toggle.style.display = 'none';
      return;
    }
    const CUT_ORDER = ['mens', 'womens'];
    const availableCuts = CUT_ORDER.filter(function (cut) {
      return adultProducts.every(function (pk) {
        return pricing.products[pk].availableCuts.includes(cut);
      });
    });
    if (!availableCuts.includes(state.cut)) {
      state.cut = availableCuts[0] || 'mens';
    }
    toggle.innerHTML = '';
    toggle.style.display = availableCuts.length <= 1 ? 'none' : '';
    availableCuts.forEach(function (cut) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'oc-cut-btn' + (cut === state.cut ? ' is-active' : '');
      btn.dataset.cut = cut;
      btn.setAttribute('aria-pressed', String(cut === state.cut));
      btn.textContent = cut.charAt(0).toUpperCase() + cut.slice(1);
      btn.addEventListener('click', function () { selectCut(cut); });
      toggle.appendChild(btn);
    });
  }

  function selectCut(cut) {
    if (state.cut === cut) return;
    state.cut = cut;
    document.querySelectorAll('.oc-cut-btn').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.cut === cut);
      btn.setAttribute('aria-pressed', String(btn.dataset.cut === cut));
    });
    renderColourBlocks();
    validateStep(5);
    updateSummary();
  }

  function renderColourBlocks() {
    const container = document.getElementById('colour-blocks');
    if (!container) return;
    container.innerHTML = '';

    const hasAny = state.productKeys.some(function (pk) {
      return (state.coloursByProduct[pk] || []).length > 0;
    });
    if (!hasAny) {
      container.innerHTML = '<p class="oc-step-hint">No colours selected — go back to step 2.</p>';
      return;
    }

    state.productKeys.forEach(function (prodKey) {
      const product = pricing.products[prodKey];
      const colours = state.coloursByProduct[prodKey] || [];
      if (!colours.length) return;
      const cut   = effectiveCut(prodKey);
      const sizes = pricing.sizes[cut];

      if (state.productKeys.length > 1) {
        const heading = document.createElement('p');
        heading.className = 'oc-qty-product-heading';
        heading.textContent = product.name;
        container.appendChild(heading);
      }

      if (!state.qtyByProductColour[prodKey]) state.qtyByProductColour[prodKey] = {};

      colours.forEach(function (colKey) {
        const colour = pricing.colours[colKey];
        if (!state.qtyByProductColour[prodKey][colKey]) state.qtyByProductColour[prodKey][colKey] = {};
        if (!state.qtyByProductColour[prodKey][colKey][cut]) state.qtyByProductColour[prodKey][colKey][cut] = {};

        let circleStyle = 'background:' + colour.hex + ';';
        if (colour.accent) {
          circleStyle = 'background:linear-gradient(135deg,' + colour.hex + ' 50%,' + colour.accent + ' 50%);';
        } else if (['#ffffff', '#c8b89a', '#D9D8D2', '#87CEEB', '#E1E6E9'].includes(colour.hex)) {
          circleStyle += 'border:1px solid #ccc;';
        }

        const totalKey = prodKey + '-' + colKey;
        const colQty   = colourQty(prodKey, colKey);
        const block    = document.createElement('div');
        block.className = 'oc-colour-block';
        const thCells = sizes.map(function (s) { return '<th scope="col">' + s + '</th>'; }).join('');
        const tdCells = sizes.map(function (s) {
          const qty = state.qtyByProductColour[prodKey][colKey][cut][s] || 0;
          return '<td><input type="number" class="oc-qty-input" min="0" step="1" value="' + qty +
            '" data-product="' + prodKey + '" data-colour="' + colKey + '" data-size="' + s + '" data-cut="' + cut +
            '" aria-label="' + colour.name + ' ' + s + ' (' + cut + ') quantity"></td>';
        }).join('');
        block.innerHTML =
          '<div class="oc-colour-block-header">' +
            '<span class="oc-colour-block-swatch" style="' + circleStyle + '"></span>' +
            '<span class="oc-colour-block-name">' + colour.name + '</span>' +
            '<span class="oc-colour-block-total" data-col-total="' + totalKey + '">' + colQty + ' shirt' + (colQty !== 1 ? 's' : '') + '</span>' +
          '</div>' +
          '<div class="oc-size-grid-wrap">' +
            '<table class="oc-size-grid" aria-label="' + colour.name + ' sizes">' +
              '<thead><tr>' + thCells + '</tr></thead>' +
              '<tbody><tr>' + tdCells + '</tr></tbody>' +
            '</table>' +
          '</div>';
        container.appendChild(block);
      });
    });

    container.querySelectorAll('.oc-qty-input').forEach(function (input) {
      input.addEventListener('input', function () {
        const prodKey = input.dataset.product;
        const colKey  = input.dataset.colour;
        const size    = input.dataset.size;
        const cut     = input.dataset.cut;
        const val     = Math.max(0, parseInt(input.value, 10) || 0);
        input.value   = val;
        if (!state.qtyByProductColour[prodKey]) state.qtyByProductColour[prodKey] = {};
        if (!state.qtyByProductColour[prodKey][colKey]) state.qtyByProductColour[prodKey][colKey] = {};
        if (!state.qtyByProductColour[prodKey][colKey][cut]) state.qtyByProductColour[prodKey][colKey][cut] = {};
        state.qtyByProductColour[prodKey][colKey][cut][size] = val;
        const colTotal = colourQty(prodKey, colKey);
        const totalKey = prodKey + '-' + colKey;
        const totalEl  = container.querySelector('[data-col-total="' + totalKey + '"]');
        if (totalEl) totalEl.textContent = colTotal + ' shirt' + (colTotal !== 1 ? 's' : '');
        validateStep(5);
        updateSummary();
        updateDiscountReminder();
      });
      input.addEventListener('blur', function () {
        if (input.value === '' || parseInt(input.value, 10) < 0) input.value = 0;
      });
    });
    updateDiscountReminder();
  }

  function colourQty(prodKey, colKey) {
    const prodData = state.qtyByProductColour[prodKey];
    if (!prodData || !prodData[colKey]) return 0;
    return Object.values(prodData[colKey]).reduce(function (sum, sizeMap) {
      return sum + Object.values(sizeMap).reduce(function (s, n) { return s + (parseInt(n, 10) || 0); }, 0);
    }, 0);
  }

  function updateDiscountReminder() {
    const el = document.querySelector('.oc-discount-reminder');
    if (!el || !pricing) return;
    const qty = totalQty();
    let msg = '';

    if (qty < MIN_ORDER) {
      const needed = MIN_ORDER - qty;
      msg = '<strong>Minimum order:</strong> ' + needed + ' more shirt' + (needed !== 1 ? 's' : '') + ' needed to reach the 12-shirt minimum.';
    } else {
      const tier      = findTier(qty);
      const tierIdx   = pricing.priceTiers.indexOf(tier);
      const nextTier  = tierIdx > 0 ? pricing.priceTiers[tierIdx - 1] : null;
      const decoFee   = totalDecoFee();
      const curTotal  = tier.basePrice + decoFee;
      msg = '<strong>$' + curTotal + '/shirt pricing applied.</strong>';
      if (nextTier) {
        const needed    = nextTier.minQty - qty;
        const nextTotal = nextTier.basePrice + decoFee;
        msg += ' Add ' + needed + ' more shirt' + (needed !== 1 ? 's' : '') + ' for $' + nextTotal + '/shirt.';
      }
    }
    el.innerHTML = msg;
  }

  // ── Step 6: logo dropzone ────────────────────────────────────────
  function setupDropzone() {
    const dropzone  = document.getElementById('oc-dropzone');
    const fileInput = document.getElementById('logo-upload');
    if (!dropzone || !fileInput) return;

    dropzone.addEventListener('click', function () { fileInput.click(); });
    dropzone.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileInput.click(); }
    });
    fileInput.addEventListener('change', function () {
      if (fileInput.files.length) handleLogoFile(fileInput.files[0]);
    });
    dropzone.addEventListener('dragover', function (e) {
      e.preventDefault();
      dropzone.classList.add('is-dragging');
    });
    dropzone.addEventListener('dragleave', function (e) {
      if (!dropzone.contains(e.relatedTarget)) dropzone.classList.remove('is-dragging');
    });
    dropzone.addEventListener('drop', function (e) {
      e.preventDefault();
      dropzone.classList.remove('is-dragging');
      if (e.dataTransfer.files.length) handleLogoFile(e.dataTransfer.files[0]);
    });
  }

  async function handleLogoFile(file) {
    const dropzone  = document.getElementById('oc-dropzone');
    const fileInput = document.getElementById('logo-upload');
    const filename  = document.getElementById('dropzone-filename');
    const existingErr = document.getElementById('dropzone-error');
    if (existingErr) existingErr.remove();

    const ext = '.' + file.name.split('.').pop().toLowerCase();
    if (!ALLOWED_EXTS.includes(ext)) {
      showDropzoneError('Please upload an AI, EPS, SVG, PDF, PNG, or JPG file.');
      return;
    }

    if (file.size > MAX_FILE_MB * 1024 * 1024) {
      state.logoFile = null;
      dropzone.classList.remove('has-file');
      showDropzoneError(
        'Your logo is over 10MB. Please email it to orders@outbackcobber.com after submitting — we\'ll match it to this order.'
      );
      validateStep(6);
      return;
    }

    try {
      const dt = new DataTransfer();
      dt.items.add(file);
      fileInput.files = dt.files;
    } catch (e) { /* older browsers — file was selected via dialog, already set */ }

    state.logoFile      = file;
    state.cloudinaryUrl = null;
    state.logoUploading = true;
    dropzone.classList.add('has-file');
    trackEvent('logo_uploaded', { file_extension: ext, file_size_kb: Math.round(file.size / 1024) });
    const hint = dropzone.querySelector('.oc-dropzone-hint');
    if (hint) hint.hidden = true;
    if (filename) { filename.textContent = 'Uploading ' + file.name + '…'; filename.hidden = false; }
    validateStep(6);

    try {
      state.cloudinaryUrl = await uploadToCloudinary(file);
      if (filename) {
        const sizeMb = (file.size / (1024 * 1024)).toFixed(1);
        filename.textContent = '✓ ' + file.name + ' (' + sizeMb + ' MB)';
      }
    } catch (e) {
      if (filename) filename.textContent = '✓ ' + file.name + ' — upload failed, please email logo after submitting.';
    }

    state.logoUploading = false;
    validateStep(6);
  }

  async function uploadToCloudinary(file) {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', CLOUDINARY_PRESET);
    const res = await fetch(
      'https://api.cloudinary.com/v1_1/' + CLOUDINARY_CLOUD + '/auto/upload',
      { method: 'POST', body: fd }
    );
    if (!res.ok) throw new Error('Cloudinary upload failed: ' + res.status);
    const data = await res.json();
    return data.secure_url;
  }

  function showDropzoneError(msg) {
    const dropzone = document.getElementById('oc-dropzone');
    if (!dropzone) return;
    const el = document.createElement('p');
    el.id        = 'dropzone-error';
    el.className = 'oc-field-error';
    el.style.marginTop = '8px';
    el.textContent = msg;
    dropzone.after(el);
  }

  // ── Step 6: contact fields ───────────────────────────────────────
  function setupContactFields() {
    const fields = {
      'contact-first-name': function (v) { state.contact.firstName    = v; },
      'contact-last-name':  function (v) { state.contact.lastName     = v; },
      'contact-email':      function (v) { state.contact.email        = v; },
      'contact-phone':      function (v) { state.contact.phone        = v; },
      'contact-street':     function (v) { state.contact.street       = v; },
      'contact-city':       function (v) { state.contact.city         = v; },
      'contact-state':      function (v) { state.contact.state        = v; },
      'contact-postcode':   function (v) { state.contact.postcode     = v; },
      'contact-country':    function (v) { state.contact.country      = v; },
      'contact-business':   function (v) { state.contact.businessName = v; },
      'contact-abn':        function (v) { state.contact.abn          = v; },
      'contact-notes':      function (v) { state.contact.notes        = v; },
      'contact-referral':   function (v) { state.contact.referral     = v; }
    };
    Object.entries(fields).forEach(function ([id, setter]) {
      const el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('input', function () {
        setter(el.value);
        validateStep(6);
      });
      el.addEventListener('blur', function () { validateContactField(id); });
    });
  }

  const CONTACT_ERRORS = {
    'contact-first-name': 'err-first-name',
    'contact-last-name':  'err-last-name',
    'contact-email':      'err-email',
    'contact-phone':      'err-phone',
    'contact-street':     'err-street',
    'contact-city':       'err-city',
    'contact-state':      'err-state',
    'contact-postcode':   'err-postcode',
    'contact-country':    'err-country',
    'contact-business':   'err-business'
  };

  function validateContactField(id) {
    const errId = CONTACT_ERRORS[id];
    if (!errId) return;
    const el  = document.getElementById(id);
    const err = document.getElementById(errId);
    if (!el || !err) return;
    let msg = '';
    if (!el.value.trim()) {
      msg = 'This field is required.';
    } else if (id === 'contact-email' && !isValidEmail(el.value)) {
      msg = 'Please enter a valid email address.';
    }
    err.textContent = msg;
    el.classList.toggle('is-invalid', !!msg);
  }

  function validateAllContactFields() {
    Object.keys(CONTACT_ERRORS).forEach(validateContactField);
  }

  // ── Form submission ──────────────────────────────────────────────
  function setupFormSubmission() {
    const form      = document.getElementById('oc-order-form');
    const submitBtn = document.getElementById('oc-submit-btn');
    if (!form) return;

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      validateAllContactFields();
      if (!isStepValid(6)) return;

      try {
        const c = state.contact;
        document.getElementById('hidden-contact-name').value = (c.firstName + ' ' + c.lastName).trim();
        document.getElementById('hidden-subject').value      = buildSubject();
        document.getElementById('hidden-body').value         = buildEmailBody();
        document.getElementById('hidden-order-data').value   = JSON.stringify(buildOrderPayload());
      } catch (err) {
        console.error('Order form: failed to build submission data', err);
        return;
      }

      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Submitting…'; }

      // Clear file input so the raw file is not re-POSTed (logo already on Cloudinary)
      const fileInput = document.getElementById('logo-upload');
      if (fileInput) fileInput.value = '';

      let fetchOk = false;
      try {
        await fetch('/contact', { method: 'POST', body: new FormData(form) });
        fetchOk = true;
      } catch (err) {
        console.error('Order form: submission failed', err);
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Submit order'; }
        showSubmitError();
      }

      if (fetchOk) {
        state.submitted = true;
        const calc = calculateTotal();
        trackEvent('form_submitted', {
          total_value:       calc.total,
          total_quantity:    calc.qty,
          products:          state.productKeys,
          decoration_method: state.methodKey
        });
        showSuccessScreen();
        if (window.oaiq) {
          oaiq("measure", "lead_created", { type: "customer_action", amount: 0, currency: "AUD" });
        }
      }
    });
  }

  function showSubmitError() {
    let el = document.getElementById('oc-submit-error');
    if (!el) {
      el = document.createElement('p');
      el.id        = 'oc-submit-error';
      el.className = 'oc-field-error';
      el.style.marginTop = '12px';
      const nav = document.querySelector('.oc-step[data-step="6"] .oc-step-nav');
      if (nav) nav.before(el);
    }
    el.textContent = 'Something went wrong. Please try again or email us at orders@outbackcobber.com.';
  }

  function buildSubject() {
    const c        = state.contact;
    const fullName = (c.firstName + ' ' + c.lastName).trim();
    const biz      = (c.businessName || '').trim() || fullName;
    return 'New Custom Workwear Order — ' + biz + ' (' + fullName + ')';
  }

  function buildEmailBody() {
    const calc   = calculateTotal();
    const method = pricing.decorationMethods[state.methodKey];
    const c      = state.contact;

    const now  = new Date();
    const dd   = String(now.getDate()).padStart(2, '0');
    const mm   = String(now.getMonth() + 1).padStart(2, '0');
    const yyyy = now.getFullYear();
    const dateStr = dd + '/' + mm + '/' + yyyy;

    const SEP = '============================================================';
    const sep = '------------------------------------------------------------';

    let body = 'NEW CUSTOM WORKWEAR ORDER\n';
    body += SEP + '\n\n';

    const fullName = (c.firstName + ' ' + c.lastName).trim();

    body += 'Date:           ' + dateStr + '\n';
    body += 'Business Name:  ' + (c.businessName || '') + '\n';
    body += 'First Name:     ' + c.firstName + '\n';
    body += 'Last Name:      ' + c.lastName + '\n';
    body += 'Phone:          ' + (c.phone || '') + '\n';
    body += 'Email:          ' + c.email + '\n';
    body += '\n';
    body += 'Street Address: ' + (c.street || '') + '\n';
    body += 'City / Suburb:  ' + (c.city || '') + '\n';
    body += 'State / Province: ' + (c.state || '') + '\n';
    body += 'Postcode:       ' + (c.postcode || '') + '\n';
    body += 'Country:        ' + (c.country || '') + '\n';
    body += '\n';

    body += sep + '\n';
    body += 'LOGO & DECORATION\n';
    body += sep + '\n';
    body += 'Logo name:   ' + (c.businessName || fullName) + '\n';
    body += 'Position:    ' + state.positions.map(function (k) { return pricing.positions[k].name; }).join(', ') + '\n';
    body += 'Method:      ' + method.name + '\n';
    body += 'Back logo?   ' + (state.positions.includes('back') ? 'Yes' : 'No') + '\n';
    body += '\n';

    body += SEP + '\n';
    body += 'ITEMS ORDERED (' + calc.qty + ' shirts total)\n';
    body += SEP + '\n\n';

    let itemNum = 0;
    state.productKeys.forEach(function (prodKey) {
      const product = pricing.products[prodKey];
      const colours = state.coloursByProduct[prodKey] || [];
      colours.forEach(function (colKey) {
        const colour      = pricing.colours[colKey];
        const prodColData = state.qtyByProductColour[prodKey] && state.qtyByProductColour[prodKey][colKey];
        if (!prodColData) return;

        product.availableCuts.forEach(function (cut) {
          const cutData  = prodColData[cut];
          if (!cutData) return;
          const cutSizes = pricing.sizes[cut];
          const entries  = cutSizes.filter(function (s) { return (parseInt(cutData[s], 10) || 0) > 0; });
          if (!entries.length) return;

          const cutLabel = cut.charAt(0).toUpperCase() + cut.slice(1);
          const itemQty  = entries.reduce(function (sum, s) { return sum + (parseInt(cutData[s], 10) || 0); }, 0);

          itemNum++;
          body += 'ITEM ' + itemNum + ' — ' + product.name + ' — ' + colour.name + ' (' + cutLabel + ')\n';
          entries.forEach(function (s) {
            body += s + ': ' + cutData[s] + '\n';
          });
          body += 'Subtotal: ' + itemQty + ' shirt' + (itemQty !== 1 ? 's' : '') + '\n\n';
        });
      });
    });

    body += SEP + '\n';
    body += 'TOTAL SHIRTS: ' + calc.qty + '\n';
    body += SEP + '\n\n';

    body += sep + '\n';
    body += 'FOR OFFICE USE ONLY\n';
    body += sep + '\n';
    const emailTier = findTier(calc.qty) || pricing.priceTiers[pricing.priceTiers.length - 1];
    body += 'Shirt price:      $' + emailTier.basePrice + '.00 +GST\n';
    body += 'Freight:          TBA\n';
    const positionLines = state.positions.map(function (p) {
      const pos = pricing.positions[p];
      const fee = (pos && pos.fee !== undefined) ? pos.fee : method.feePerPosition;
      return (pos ? pos.name : p) + ': $' + fee.toFixed(2) + ' +GST';
    }).join(', ');
    if (state.methodKey === 'embroidery') {
      body += 'Embroidery:       ' + positionLines + '\n';
      body += 'Digital Transfer: \n';
    } else {
      body += 'Embroidery:       \n';
      body += 'Digital Transfer: ' + positionLines + '\n';
    }
    body += '\n';

    body += 'Logo file:        ';
    if (state.cloudinaryUrl) {
      body += state.cloudinaryUrl + '\n';
    } else if (state.logoFile) {
      body += state.logoFile.name + ' (upload failed — customer to email logo to orders@outbackcobber.com)\n';
    } else {
      body += 'Customer to email logo to orders@outbackcobber.com\n';
    }

    if (c.abn)      body += '\nABN: ' + c.abn + '\n';
    if (c.notes)    body += '\nCustomer notes: ' + c.notes + '\n';
    if (c.referral) body += 'Referral: ' + c.referral + '\n';

    body += '\n' + sep + '\n';
    body += 'This order was submitted via the Custom Workwear form at outbackcobber.com.\n';

    return body;
  }

  function buildOrderPayload() {
    return {
      products:           state.productKeys,
      coloursByProduct:   state.coloursByProduct,
      method:             state.methodKey,
      threadColours:      state.threadColours,
      positions:          state.positions,
      cut:                state.cut,
      qtyByProductColour: state.qtyByProductColour,
      contact:            state.contact,
      totals:             calculateTotal()
    };
  }

  // ── Navigation ───────────────────────────────────────────────────
  function setupNavigation() {
    document.querySelectorAll('.oc-btn-next').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const step = parseInt(btn.dataset.step, 10);
        if (isStepValid(step)) goToStep(step + 1);
      });
    });
    document.querySelectorAll('.oc-btn-back').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goToStep(parseInt(btn.dataset.step, 10) - 1);
      });
    });
    const mobileContinue = document.getElementById('oc-mobile-continue');
    if (mobileContinue) {
      mobileContinue.addEventListener('click', function () {
        if (isStepValid(state.step)) goToStep(state.step + 1);
      });
    }
  }

  function goToStep(n) {
    if (n < 1 || n > 6) return;
    const prev = state.step;
    if (n === 2) renderColourGrid();
    if (n === 4) renderPositionGrid();
    if (n === 5) setupStep5();
    if (n > prev) trackEvent('step_completed', { step_number: prev });
    state.step = n;
    showStep(n);
    updateProgress();
    validateStep(n);
    updateSummary();
    const formTop = document.querySelector('.oc-form-col');
    if (formTop) formTop.scrollIntoView({ behavior: 'smooth', block: 'start' });
    announce('Step ' + n + ' of 6');
  }

  function showStep(n) {
    document.querySelectorAll('.oc-step').forEach(function (el) {
      el.classList.toggle('is-active', parseInt(el.dataset.step, 10) === n);
    });
    // Move focus to the step heading for keyboard and screen reader users
    const heading = document.querySelector('.oc-step.is-active .oc-step-heading');
    if (heading) {
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    }
  }

  // ── Progress bar ─────────────────────────────────────────────────
  function updateProgress() {
    const fill = document.querySelector('.oc-progress-fill');
    if (fill) fill.style.width = ((state.step / 6) * 100) + '%';
    const bar = document.querySelector('.oc-progress-bar');
    if (bar) bar.setAttribute('aria-valuenow', state.step);
    document.querySelectorAll('.oc-progress-step').forEach(function (el) {
      const n = parseInt(el.dataset.step, 10);
      el.classList.toggle('is-active', n === state.step);
      el.classList.toggle('is-done', n < state.step);
      if (n === state.step) {
        el.setAttribute('aria-current', 'step');
      } else {
        el.removeAttribute('aria-current');
      }
    });
  }

  // ── Validation ───────────────────────────────────────────────────
  function isStepValid(step) {
    switch (step) {
      case 1: return state.productKeys.length >= 1;
      case 2: return state.productKeys.length >= 1 && state.productKeys.every(function (pk) {
        return (state.coloursByProduct[pk] || []).length >= 1;
      });
      case 3:
        if (!state.methodKey) return false;
        if (pricing.decorationMethods[state.methodKey].needsThreadColour) {
          const threadInput = document.getElementById('thread-colour-input');
          if (threadInput && !state.threadColours) return false;
        }
        return true;
      case 4: return state.positions.length >= 1;
      case 5: return totalQty() >= MIN_ORDER;
      case 6: {
        if (state.logoUploading) return false;
        const c = state.contact;
        return !!state.logoFile &&
          c.firstName.trim()  !== '' &&
          c.lastName.trim()   !== '' &&
          c.email.trim()      !== '' && isValidEmail(c.email) &&
          c.phone.trim()      !== '' &&
          c.street.trim()     !== '' &&
          c.city.trim()       !== '' &&
          c.state.trim()      !== '' &&
          c.postcode.trim()     !== '' &&
          c.country.trim()      !== '' &&
          c.businessName.trim() !== '';
      }
      default: return false;
    }
  }

  function validateStep(step) {
    const valid   = isStepValid(step);
    const nextBtn = document.querySelector('.oc-btn-next[data-step="' + step + '"]');
    if (nextBtn) nextBtn.disabled = !valid;
    const submitBtn = document.getElementById('oc-submit-btn');
    if (step === 6 && submitBtn) submitBtn.disabled = !valid;
    if (step === state.step) {
      const mob = document.getElementById('oc-mobile-continue');
      if (mob) mob.disabled = !valid;
    }
  }

  // ── Pricing calculator ────────────────────────────────────────────
  function findTier(qty) {
    return pricing.priceTiers.find(function (t) { return qty >= t.minQty; });
  }

  function positionFee(posKey) {
    const pos = pricing.positions[posKey];
    return (pos && pos.fee !== undefined) ? pos.fee : pricing.decorationMethods[state.methodKey].feePerPosition;
  }

  function totalDecoFee() {
    if (!state.methodKey || !state.positions.length) return 0;
    return state.positions.reduce(function (sum, p) { return sum + positionFee(p); }, 0);
  }

  function calculateTotal() {
    if (!pricing || !state.productKeys.length || !state.methodKey) {
      return { qty: 0, perShirt: 0, subtotal: 0, discount: 0, discountPct: 0, total: 0 };
    }
    const qty      = totalQty();
    const tier     = findTier(qty) || pricing.priceTiers[pricing.priceTiers.length - 1];
    const perShirt = tier.basePrice + totalDecoFee();
    const subtotal = qty * perShirt;
    return { qty: qty, perShirt: perShirt, subtotal: subtotal, discount: 0, discountPct: 0, total: subtotal };
  }

  function totalQty() {
    return Object.values(state.qtyByProductColour).reduce(function (prodSum, colMap) {
      return prodSum + Object.values(colMap).reduce(function (colSum, cutMap) {
        return colSum + Object.values(cutMap).reduce(function (cutSum, sizeMap) {
          return cutSum + Object.values(sizeMap).reduce(function (s, n) { return s + (parseInt(n, 10) || 0); }, 0);
        }, 0);
      }, 0);
    }, 0);
  }

  // ── Summary panel ────────────────────────────────────────────────
  function updateSummary() {
    if (!pricing) return;
    setSum('product', state.productKeys.length
      ? state.productKeys.map(function (pk) { return pricing.products[pk].name; }).join(', ')
      : '—');
    const allSelectedColours = [];
    state.productKeys.forEach(function (pk) {
      (state.coloursByProduct[pk] || []).forEach(function (ck) { allSelectedColours.push(pricing.colours[ck].name); });
    });
    setSum('colours', allSelectedColours.length ? allSelectedColours.join(', ') : '—');
    setSum('method', state.methodKey ? pricing.decorationMethods[state.methodKey].name : '—');
    setSum('positions', state.positions.length
      ? state.positions.map(function (k) { return pricing.positions[k].name; }).join(', ')
      : '—');
    const qty = totalQty();
    setSum('qty', qty > 0 ? qty + ' shirts' : '—');

    // Per-shirt price
    let perShirtText = '—';
    if (state.productKeys.length) {
      const tier = findTier(totalQty()) || pricing.priceTiers[pricing.priceTiers.length - 1];
      if (state.methodKey) {
        const method   = pricing.decorationMethods[state.methodKey];
        const perShirt = tier.basePrice + totalDecoFee();
        perShirtText   = '$' + perShirt + ' +GST';
      } else {
        perShirtText = 'From $' + tier.basePrice + ' +GST';
      }
    }
    setSum('per-shirt', perShirtText);
    const mobPerShirt = document.getElementById('mobile-bar-per-shirt');
    if (mobPerShirt) mobPerShirt.textContent = perShirtText;

    const calc = calculateTotal();
    setSum('subtotal', calc.subtotal > 0 ? '$' + calc.subtotal + ' +GST' : '—');
    document.querySelectorAll('[data-sum-row="discount"]').forEach(function (row) {
      row.hidden = calc.discount === 0;
    });
    if (calc.discount > 0) {
      setSum('discount', '-$' + calc.discount + ' (' + Math.round(calc.discountPct * 100) + '% — ' + qty + '+ qty tier)');
    }
    setSum('total', calc.total > 0 ? '$' + calc.total + ' +GST' : '—');
    const mobTotal = document.getElementById('mobile-bar-total');
    if (mobTotal) mobTotal.textContent = calc.total > 0 ? '$' + calc.total + ' +GST' : '$0 +GST';
  }

  // ── Mobile bar / sheet ────────────────────────────────────────────
  function setupMobileBar() {
    const toggle = document.getElementById('oc-mobile-bar-toggle');
    const sheet  = document.getElementById('oc-mobile-sheet');
    if (toggle && sheet) {
      toggle.addEventListener('click', function () {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        sheet.style.display = expanded ? 'none' : 'block';
        sheet.classList.toggle('is-open', !expanded);
        sheet.setAttribute('aria-hidden', String(expanded));
      });
    }
    const closeBtn = document.querySelector('.oc-mobile-sheet-close');
    if (closeBtn && sheet && toggle) {
      closeBtn.addEventListener('click', function () {
        sheet.classList.remove('is-open');
        sheet.style.display = 'none';
        sheet.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-expanded', 'false');
      });
    }
  }

  // ── Success / error screens ──────────────────────────────────────
  function checkSubmissionResult() {
    if (window.location.search.indexOf('contact_posted=true') !== -1) {
      showSuccessScreen();
      return true;
    }
    return false;
  }

  function showSuccessScreen() {
    const form     = document.getElementById('oc-order-form');
    const progress = document.querySelector('.oc-progress');
    if (form)     form.style.display     = 'none';
    if (progress) progress.style.display = 'none';
    const card = document.createElement('div');
    card.className = 'oc-success-card';
    card.innerHTML =
      '<div class="oc-success-icon">✓</div>' +
      '<h2 class="oc-success-heading">Thanks, we\'ve got your order.</h2>' +
      '<p>Check your email in the next 5 minutes for a confirmation. Your invoice will arrive within 24 hours.</p>' +
      '<p>We\'ll only come back to you if there\'s a problem with your logo file. If you don\'t hear from us about the artwork, you\'re all good.</p>' +
      '<button type="button" class="oc-btn oc-btn-primary" onclick="window.location.href=window.location.pathname">Place another order</button>';
    const col = document.querySelector('.oc-form-col');
    if (col) col.appendChild(card);
    card.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ── Analytics ─────────────────────────────────────────────────────
  function trackEvent(name, params) {
    try { if (window.gtag) window.gtag('event', name, params); } catch (e) { /* silent */ }
  }

  // ── Utilities ─────────────────────────────────────────────────────
  function setSum(key, text) {
    document.querySelectorAll('[data-sum="' + key + '"]').forEach(function (el) { el.textContent = text; });
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function announce(msg) {
    const region = document.querySelector('.oc-sr-announce');
    if (!region) return;
    region.textContent = '';
    requestAnimationFrame(function () { region.textContent = msg; });
  }

  // ── Init ──────────────────────────────────────────────────────────
  async function init() {
    try {
      pricing = await fetchPricing();
    } catch (e) {
      console.error('Outback Cobber order form: failed to load pricing data', e);
      return;
    }
    if (checkSubmissionResult()) return;
    const formEl = document.getElementById('oc-order-form');
    if (formEl) formEl.setAttribute('novalidate', '');
    renderProductGrid();
    showStep(1);
    updateProgress();
    validateStep(1);
    setupNavigation();
    setupMethodSelection();
    setupDropzone();
    setupContactFields();
    setupFormSubmission();
    setupMobileBar();

    let started = false;
    const grid = document.getElementById('product-grid');
    if (grid) {
      grid.addEventListener('click', function () {
        if (!started) { started = true; trackEvent('form_started', {}); }
      });
    }

    // Fire step_abandoned with the last step reached when user leaves the page
    window.addEventListener('beforeunload', function () {
      if (state.step > 1 && !state.submitted) {
        trackEvent('step_abandoned', { last_step: state.step });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
